@if (isLoading() && !isSiteAndHubReport()) {
  <div style="display: flex; justify-content: center; padding-top: 10px">
    <gc-loading-spinner />
  </div>
}
@if (spanGeoJson$ | async) {
  @if (spanProperties) {
    <app-report-view-v2 [spanPropertiesArray]="spanPropertiesArray" />
  } @else {
    <ng-container *ngTemplateOutlet="errorScreen" />
  }
} @else if (distributionPointGeoJson$ | async) {
  @if (distributionPointProperties?.properties) {
    @if (isSiteAndHubReport()) {
      <app-report-view
        [ifs]="ifs()"
        [typeId]="typeId()"
        [id]="id()"
        [distributionPointProperties]="distributionPointProperties"
      />
    } @else {
      <app-report-view-v2
        [pointProperties]="distributionPointProperties?.properties"
      />
    }
  } @else {
    <ng-container *ngTemplateOutlet="errorScreen" />
  }
}
<ng-template #errorScreen>
  <div
    [style]="{
      display: 'flex',
      justifyContent: 'center',
      paddingTop: '10px',
    }"
  >
    <app-error-information
      [iconName]="'smileySad'"
      [iconColor]="'caution'"
      [errorString]="
        typeId() === 'SPAN'
          ? 'reportInput.noSpanReport'
          : ('reportInput.noPointReport' | translate)
      "
    />
  </div>
</ng-template>
